import { render, staticRenderFns } from "./TenantEdit.vue?vue&type=template&id=41455fd1"
import script from "./TenantEdit.vue?vue&type=script&lang=ts"
export * from "./TenantEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports